import { render } from "./Task.vue?vue&type=template&id=47a9686e"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"
script.render = render

export default script